import { Plant } from './ModelSeries';

export interface Match {
  params: {
    id: string;
    version: string;
    tab: string;
  };
  path: string;
}

export type LangTextMandatory = {
  DE: string;
  EN: string;
};

export type LangText = Partial<LangTextMandatory>;

export type UserInfo = {
  code: string;
  department: string;
  summary: string;
};

type TableForm = {
  EN: string;
  DE: string;
  active?: boolean;
};

export type ReduxForms = {
  [formKey: string]: { options: { [optionKey: string]: TableForm }; modified: boolean };
};

export type FeedbackCustomFormOption = {
  EN: string;
  DE: string;
  enumAPI: string;
};

export type FeedbackCustomForm = {
  options: FeedbackCustomFormOption[];
};

export interface LanguagesForm {
  [key: string]: { [key: string]: string };
}

export type ReduxFormsState = {
  [tab: string]: ReduxForms | string[] | LanguagesForm | Plant[] | FeedbackCustomForm;
  campaignStatuses: string[];
  subCampaignStatuses: string[];
  languages: LanguagesForm;
  plants: Plant[];
};

export interface UserSearch {
  costCenter: string;
  country: string;
  department: string;
  email: string;
  firstName: string;
  groupType: string;
  lastName: string;
  level: number;
  mobilePhone: string;
  organisation: string;
  phone: string;
  plant1: string;
  plant2: string;
  roleSelected: null;
  rolesList: null;
  selected: boolean;
  standInList: null;
  supervisor: string;
  userCode: string;
  userType: string;
  standInOfList: string[];
  roles: string[];
}

export interface RouterParams {
  version: string;
  id: string;
  helpTab?: string;
  fieldsTab?: string;
}

export type InputVariants = 'standard' | 'outlined' | 'filled';
export type SizeVariants = 'xs' | 'sm' | 'md' | 'lg' | 'xl';

export enum Language {
  EN = 'EN',
  DE = 'DE',
}

export type AvailableLanguage = {
  code: string;
  name: {
    [name: string]: string;
  };
};

export type Address = {
  city: string;
  country: string;
  postalCode: string;
  street: string;
};

export type PlantReduced = {
  plantName: string;
  plantAccountingNumber: string;
  plantPsNumber: string;
  wkzNumber: string;
};

export type AlertSnackbarSeverities = 'Error' | 'Success' | 'Warning' | 'Info' | 'Fixed' | 'ERROR';

type YES = 'YES';

type NO = 'NO';

export type YESorNO = YES | NO;

export type LANGS = 'EN' | 'DE';

export type SelectedFieldsByTab = {
  [tab: string]: string[];
};

export type HighlightedFields = {
  isSelectionMode: boolean;
  selectedFields: SelectedFieldsByTab;
  reviewerComment: string;
};
